import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { InteriorSlide, SlideHeader, SlideBanner } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide09Metrics({
  index
}: SlideProps) {
  return <InteriorSlide surface data-id="element-210">
      <SlideHeader eyebrow="Proof It Works" data-id="element-211">The GSK Africa Model</SlideHeader>

      <div className="flex-1 flex flex-col lg:flex-row items-center gap-12 lg:gap-16 max-w-6xl mx-auto w-full" data-id="element-212">
        {/* Left: Content */}
        <div className="flex-1 space-y-8 w-full" data-id="element-213">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3,
          duration: 0.6
        }} data-id="element-214">
            <h2 className="text-3xl md:text-5xl font-bold text-[var(--fg)] tracking-tight mb-6" data-id="element-215">
              This isn't a new idea.
              <br data-id="element-216" />
              <span className="text-[var(--brand)]" data-id="element-217">
                We're already doing it.
              </span>
            </h2>
            <p className="text-[clamp(1.1rem,1.4vw,1.3rem)] text-[var(--muted)] leading-relaxed" data-id="element-218">
              In Nigeria and Kenya, Snakker runs GSK Africa's HCP campaigns
              end-to-end. Low cost. High impact. The brand team gets results —
              not requests.
            </p>
          </motion.div>

          <div className="space-y-4" data-id="element-219">
            {['Full campaign strategy per brand', 'Mobile-first Snak content built for African HCP behaviour', 'Quiz-based engagement that maps HCPs on the adoption ladder', 'Multi-channel distribution: WhatsApp, QR, web', 'Real-time data and optimization', 'Country-by-country localization'].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.5 + i * 0.1,
            duration: 0.5
          }} className="bg-white p-4 rounded-2xl shadow-sm border border-black/5 flex items-center gap-4" data-id="element-220">
                <div className="h-8 w-8 rounded-full bg-[var(--surface)] flex items-center justify-center flex-shrink-0" data-id="element-221">
                  <CheckCircle2 className="h-5 w-5 text-[var(--brand)]" data-id="element-222" />
                </div>
                <span className="font-medium text-[var(--fg)]" data-id="element-223">{item}</span>
              </motion.div>)}
          </div>
        </div>

        {/* Right: Visual */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} className="flex-1 w-full relative aspect-[4/5] max-w-md rounded-3xl overflow-hidden shadow-2xl border-8 border-white" data-id="element-224">
          <img src="https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?w=1200&q=80" alt="African healthcare workers reviewing results together" className="w-full h-full object-cover" data-id="element-225" />
          <div className="absolute inset-0 bg-gradient-to-t from-[var(--brand)]/60 via-transparent to-transparent mix-blend-multiply" data-id="element-226" />
        </motion.div>
      </div>
    </InteriorSlide>;
}